// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mquB","label":"styles_label__eSpoE"};